import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeItem: null,   
  activeSubItem: null, 
};

const activeRouteSlice = createSlice({
  name: 'activeRoute',
  initialState,
  reducers: {
    setActiveItem: (state, action) => {
      state.activeItem = action.payload;
    },
    setActiveSubItem: (state, action) => {
      state.activeSubItem = action.payload;
    },
    resetActiveRoute: (state) => {
      state.activeItem = null;
      state.activeSubItem = null;
    },
  },
});

export const { setActiveItem, setActiveSubItem, resetActiveRoute } = activeRouteSlice.actions;
export default activeRouteSlice.reducer;
